<template>
  <div>
    <div
    ref="cloak"
    class="cloak"
    :class="isShow ? 'isShow': 'isHidden'"
    @mousedown="down"
    @mousemove="move"
    @mouseup="end"
    @touchstart="down"
    @touchmove="move"
    @touchend="end">
      <!-- <div class="btn" @click="switchBtn">×</div> -->
      <div class="content">
        <div class="img">
          <img :src="conInfo.qrcode" alt="">
        </div>
        <div class="word">想要批量报名或更多优惠？</div>
        <div class="word" v-if="conInfo.name">立即联系票务{{conInfo.name}}</div>
        <div class="word" v-if="conInfo.phone">或致电：<a :href="'tel:' + conInfo.phone" class="tel">{{conInfo.phone}}</a></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      postX: '',
      nowX: '',
      distanceX: '',
      divX: '',
      divY: '',
      touching: false,
      elIconLink: this.$refs.cloak,
      screenWidth: window.document.body.clientWidth
    }
  },
  props: {
    isShow: Boolean,
    conInfo: {
      type: Object,
      default: () => {
        return {
          phone: '',
          name: '',
          qrcode: '' // 公众号
        }
      }
    }
  },
  methods: {
    // leave () {
    //   console.log(this.endPosition)
    //   let keyframes = document.getElementById('keyframes')
    //   let head = document.getElementsByTagName('head')[0]
    //   let animationRules = `@keyframes cloakHidden { from {-webkit-clip-path: circle(100vh at ` + this.endPosition.xPum + 'px ' + this.endPosition.yPum + `px);clip-path: circle(100vh at ` + this.endPosition.xPum + 'px ' + this.endPosition.yPum + `px) } 99% {-webkit-clip-path: circle(20vw at ` + this.endPosition.xPum + 'px ' + this.endPosition.yPum + `px);clip-path: circle(20vw at ` + this.endPosition.xPum + 'px ' + this.endPosition.yPum + `px)};100% { display: none }}`
    //   if (keyframes) {
    //     keyframes.innerHTML = animationRules
    //     head.appendChild(keyframes)
    //   } else {
    //     var style = document.createElement('style')
    //     style.type = 'text/css'
    //     style.id = 'keyframes'
    //     style.innerHTML = animationRules
    //     head.appendChild(style)
    //   }
    // },
    down: function (event) {
      // console.log('down')
      var events = (event.touches && event.touches[0]) || event
      this.postX = events.clientX
      // this.nowX = this.postX
      this.divX = this.$refs.cloak.offsetLeft
      this.divY = this.$refs.cloak.offsetTop
      this.$refs.cloak.style.transition = ''
    },
    move: function (event) {
      // console.log('move')
      var events = (event.touches && event.touches[0]) || event
      this.distanceX = events.clientX - this.postX
      // 防止 左滑
      if (this.distanceX + this.divX > 0) {
        this.$refs.cloak.style.left = this.distanceX + this.divX + 'px'
      }
      let endPos = {
        x: this.distanceX,
        y: events.clientY - this.divY
      }
      let isScrolling = Math.abs(endPos.x) < Math.abs(endPos.y) ? 0 : 1
      // isScrolling为 0 时，表示纵向滑动，1 为横向滑动
      if (isScrolling === 0) {
        // 阻止触摸事件的默认行为，即阻止滚屏
        event.preventDefault()
      }
      this.$emit('pushPerc', (this.distanceX + this.divX) / this.screenWidth)
    },
    end: function () {
      // console.log('end')
      this.$refs.cloak.style.transition = 'all 0.3s ease-in-out'
      // this.$refs.cloak.style.left = this.distanceX + this.divX + 'px'
      if (this.distanceX + this.divX < this.screenWidth / 2) {
        this.$refs.cloak.style.left = '0px'
        this.$emit('pushPerc', 0)
      } else {
        this.$refs.cloak.style.left = this.screenWidth + 'px'
        this.$emit('pushPerc', 1)
        this.$emit('switchBtn')
        window.setTimeout(() => {
          this.$refs.cloak.style.left = '0px'
        }, 300)
      }
    }
  }
}
</script>
<style scoped lang='sass'>
@keyframes cloakDisplay
  from
    -webkit-clip-path: circle(20vw at 50vw 50vh)
    clip-path: circle(20vw at 50vw 50vh)
  to
    -webkit-clip-path: circle(100vh at 50vw 50vh)
    clip-path: circle(100vh at  50vw 50vh)

.cloak
  position: fixed
  top: 0
  z-index: 1000000
  width: 100%
  height: 100vh
  background-color: #fff
  align-items: center
  justify-content: center
  box-shadow: 0px 0px 8px 6px rgba(7,17,27,.1)
  &.isHidden
    display: none
  &.isShow
    display: flex
    animation: cloakDisplay 1s 1
  .btn
    font-size: 38px
    position: absolute
    top: 0
    left: 20px
  .content
    .img
      width: 200px
      img
    .word
      text-align: center
      .tel
        color: var(--primary-color)
</style>
